import gql from 'graphql-tag';
import { participantFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const updateParticipantMutation = gql`
  mutation UpdateParticipant($id: ID!, $input: UpdateParticipantInput!) {
    updateParticipant(id: $id, input: $input) {
      ...AdminSanityDocumentFields
      ...AdminParticipantFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${participantFieldsFragment}
`;